import React from 'react';
import { Switch } from 'react-router-dom';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { EndpointEvaluator, Quest } from 'cccisd-laravel-assignment';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { ResourceCenter } from 'cccisd-laravel-resources';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome'; // Include it into main bundle
import Register from './pages/Register'; // Include it into main bundle
import OnlineTraining from './pages/OnlineTraining';
import AllCourseProgress from './pages/AllCourseProgress';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';

// Bind MainLayout by default
const AppRoute = p => <Route layout={MainLayout} {...p} />;
const MainLayoutFluid = p => <MainLayout className="container-fluid" {...p} />;
const MainLayoutSecondaryNav = p => <MainLayout showSecondaryNav {...p} />;
const MainLayoutFluidSecondaryNav = p => <MainLayout showSecondaryNav className="container-fluid" {...p} />;

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const componentMatch = {
    AppdefManage,
    ResourceCenter,
    Welcome,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutSecondaryNav,
    MainLayoutFluidSecondaryNav,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}
        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/welcome" component={Welcome} />
        <AppRoute path="/register" component={Register} />
        <AppRoute path="/login" component={Register} />
        {Fortress.hasAccess('app.allCourseProgress') && <AppRoute path="/all-progress" component={AllCourseProgress} />}

        <AppRoute
            path="/onlinetraining/:tab?/:id?"
            component={OnlineTraining}
            componentProps={{ handle: 'onlinetrainings' }}
            layout={MainLayoutFluid}
            layoutProps={{ banner: 'Online Training' }}
        />

        <AppRoute exact path="/course/:endpoint/:shortHash?" component={EndpointEvaluator} />
        <AppRoute
            path={['/quest/preview', '/d', '/survey']}
            component={Quest}
            componentProps={{
                errorLayout: MainLayout,
                registrationUrlsByRole: {
                    learner: '/register',
                },
            }}
            layout={QuestLayout}
        />

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        <AppRoute path="/account" component={Nexus} />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} />
    </Switch>
);
